import { render, staticRenderFns } from "./DiagnosisHistory.vue?vue&type=template&id=6c22eca4&"
import script from "./DiagnosisHistory.vue?vue&type=script&lang=ts&"
export * from "./DiagnosisHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c22eca4')) {
      api.createRecord('6c22eca4', component.options)
    } else {
      api.reload('6c22eca4', component.options)
    }
    module.hot.accept("./DiagnosisHistory.vue?vue&type=template&id=6c22eca4&", function () {
      api.rerender('6c22eca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/history/DiagnosisHistory.vue"
export default component.exports